import { addDays, endOfDay } from 'date-fns';
import { HabitSchedule } from 'shared/types/habit-schedule';

export const getScheduleEndDate = (schedule?: HabitSchedule | null) =>
  schedule?.endDate ? endOfDay(addDays(schedule.endDate, -1)) : undefined;
